
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import SelecionarTipoFrete from '@/components/Compartilhados/SelecionarTipoFrete.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { INotaFiscal, INotaFiscalTransporteVolume } from '@/models/Entidades/Fiscal/INotaFiscal';
import RecebimentoMercadoriasFreteVolume from './NotaFiscalFreteVolume.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { ETipoRelacaoPessoa } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoRelacaoPessoa';
import SelecionarPessoa from '@/components/Cadastros/Pessoas/SelecionarPessoa.vue';

export default defineComponent({
  name: 'NotaFiscalFrete',
  props: {
    notaFiscal: {
      type: Object as () => INotaFiscal,
      required: true,
    },
    mostrarOutrosValores: {
      type: Boolean,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    selecaoManualTipoFrete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Card,
    SelecionarTipoFrete,
    CampoNumerico,
    SelecionarPessoa,
    RecebimentoMercadoriasFreteVolume,
    MensagemSemDados,
  },
  emits: ['update:notaFiscal', 'totalAlterado', 'campoAlterado', 'update:selecaoManualTipoFrete'],
  setup(props, { emit }) {
    const computedNotaFiscal = computed({
      get: () => props.notaFiscal,
      set: (val: INotaFiscal) => {
        emit('update:notaFiscal', val);
      },
    });
    const computedSelecaoManualTipoFrete = computed({
      get: () => props.selecaoManualTipoFrete,
      set: (val: boolean) => {
        emit('update:selecaoManualTipoFrete', val);
      },
    });
    function totalAlterado() {
      emit('totalAlterado');
    }

    function campoAlterado() {
      emit('campoAlterado');
    }

    function adicionarVolume() {
      const volume = {} as INotaFiscalTransporteVolume;
      computedNotaFiscal.value.transporte.volumes.push(volume);
    }

    function removerVolume(index: number) {
      computedNotaFiscal.value.transporte.volumes.splice(index, 1);
      campoAlterado();
    }

    const state = reactive({
      codigoTransportadora: 0,
    });

    function atualizarTipoFreteManual() {
      if (props.selecaoManualTipoFrete) {
        computedSelecaoManualTipoFrete.value = true;
      }
    }
    return {
      props,
      state,
      ETipoRelacaoPessoa,
      computedNotaFiscal,
      adicionarVolume,
      campoAlterado,
      removerVolume,
      totalAlterado,
      atualizarTipoFreteManual,
    };
  },
});
